import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/shape/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/shape/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleContextProvider"] */ "/vercel/path0/frontend/src/providers/LocaleContextProvider.tsx");
